import { render } from "./AddEditSeat.vue?vue&type=template&id=3097532c&ts=true"
import script from "./AddEditSeat.vue?vue&type=script&lang=ts"
export * from "./AddEditSeat.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\wamp64\\www\\hayllissac\\sistema\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__